import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import Buefy from 'buefy'
import VeeValidate from 'vee-validate';


import 'buefy/dist/buefy.css'
import "@/assets/global.css"

Vue.use(VeeValidate);
Vue.use(VueRouter)
Vue.use(Buefy)
Vue.config.productionTip = false

Vue.prototype.$appName = 'Bosspour'

const Start = () => import('./components/Start.vue')
const Manager = () => import('./components/Manager.vue')
const Vote2 = () => import('./components/Vote2.vue')
const VoteConfirmed = () => import('./components/VoteConfirmed.vue')
const About = () => import('./components/About.vue')
const CompetitionsMain = () => import('./components/CompetitionsMain.vue')
const PreviousCompetitionsMain = () => import('./components/PreviousCompetitionsMain.vue')
const CompetitionSummaryTwo = () => import('./components/CompetitionSummary2.vue')
const BayesianCompetition = () => import('./components/BayesianCompetition.vue')
const VotesSummary = () => import('./components/VotesSummary.vue')
const BrewersChoiceResult = () => import('./components/BrewersChoiceResult.vue')
const CompetitionResults = () => import('./components/CompetitionResults.vue')
const WelcomeTexts = () => import('./components/WelcomeTexts.vue')
const ReserveKeyword = () => import('./components/ReserveKeyword.vue')

const routes = [
  { path: '/', name: 'start', component: Start },
  { path: '/vote', name: 'vote', component: Vote2, props: (route) => ({ competitionId: route.query.competitionId, voteKey: route.query.voteKey, visitorId: route.query.visitorId }) },
  { path: '/manager', name: 'manager', component: Manager, props: (route) => ({ competitionId: route.query.competitionId, apiKey: route.query.apiKey }) },
  { path: '/welcometexts', name: 'welcometexts', component: WelcomeTexts, props: true },
  { path: '/voteconfirmed', name: 'voteconfirmed', component: VoteConfirmed, props: false },
  { path: '/about', name: 'about', component: About },
  { path: '/competitionslist', name: 'competitionslist', component: CompetitionsMain },
  { path: '/votessummary/:competitionId', name: 'votessummary', component: VotesSummary, props: true },
  { path: '/brewerschoiceresult/:competitionId', name: 'brewerschoiceresult', component: BrewersChoiceResult, props: true },
  { path: '/previouscompetitionslist', name: 'previouscompetitionslist', component: PreviousCompetitionsMain },
  { path: '/competition/:competitionId', name: 'competition2', component: CompetitionSummaryTwo, props: true },
  { path: '/competitionv2/:competitionId', name: 'bayesiancompetition', component: BayesianCompetition, props: true },
  { path: '/competitionresults/:competitionId', name: 'competitionresults', component: CompetitionResults, props: true },
  { path: '/reserveKeyword', name: 'reservekeyword', component: ReserveKeyword, props: (route) => ({ competitionId: route.query.competitionId, voteKey: route.query.voteKey, visitorId: route.query.visitorId }) },

  {
      path: '/current', name: 'current', component: BayesianCompetition, props: function (route) {
      return Object.assign({}, route.params, {
          competitionId: '79f2be24-dc5a-4072-a7de-d743c0f0294c',
          brewId: route.params.brewId
      })
    }
  }

]

const router = new VueRouter({
  routes
})

// Add navigation guard to handle hash
router.beforeEach((to, from, next) => {
    const brewIdMatch = window.location.hash.match(/#brewId=(\d+)$/);
    // Check if there's a hash and we're at the root
    if (brewIdMatch && to.path === '/') {
        const brewId = brewIdMatch[1]; // Remove the # character

        if (router.currentRoute.name === 'current' || router.currentRoute.name === 'bayesiancompetition') {
            next();
            // After navigation completes, do the search
            router.app.$nextTick(() => {
                const bayesianComponent = router.app.$root.$children[0].$refs.bayesianComponent;
                if (bayesianComponent) {
                    bayesianComponent.searchQuery = brewId;
                    bayesianComponent.searchBrew();
                }
            });
        }
        else {
            // Redirect to current page with brewId as data
            next({
                name: 'current',
                params: { brewId: brewId }
            })
        }
    } else {
        next()
    }
})

// Handle hash changes without page reload
window.addEventListener('hashchange', () => {
    const brewIdMatch = window.location.hash.match(/#brewId=(\d+)$/);

    if (brewIdMatch) {
        const brewId = brewIdMatch[1];
        if (router.currentRoute.name === 'current' || router.currentRoute.name === 'bayesiancompetition') {
            const app = router.app;
            // Get the BayesianCompetition instance
            const bayesianComponent = app.$root.$children[0].$refs.bayesianComponent;
            if (bayesianComponent) {
                bayesianComponent.searchQuery = brewId;
                bayesianComponent.searchBrew();
            }
        }
        else {
            router.push({
                name: 'current',
                params: { brewId: brewId }
            })
        }
    }
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
